import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as queryString from 'query-string';

import { getRatingDetails, setRatingChoice } from '../../../utils';
import { getPickleballRatingDescriptionV2, getReturnPageName } from './constants';
import { setShowRating } from '../../../actions/onboarding-actions';

import styles from '../nuoV2.scss';
import PickleballScale from './PickleballScale';

const PickleballRating = (props) => {
    const { location } = props;
    const profile = useSelector(({ profile }) => profile);
    const dispatch = useDispatch();

    const parsed = queryString.parse(location.search);
    const rating = getRatingDetails(
        setRatingChoice({ player: profile.data }),
        false,
        true,
        false,
        false,
    );

    const handleNextClick = () => {
        dispatch(setShowRating(false, null));
    };

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.pickleball-rating.title">
                Your <span className={`${styles.ratingType} ${styles.pickleball}`}>UTR-P</span> pickleball rating is :
            </div>
            <div className="row">
                <div className={`col`}>
                    <div className={styles.ratingContainer}>
                        <div className={styles.rating} data-testid="nuo-v2.pickleball-rating.rating-value">
                            {rating?.pkbRating?.value}
                        </div>
                        <div className={styles.description} data-testid="nuo-v2.pickleball-rating.description">
                            Based on your responses, you have been assigned a {rating?.pkbRating?.value} rating. This rating most closely resembles {getPickleballRatingDescriptionV2(rating?.pkbRating?.value)} players. Meet and compete with other players by joining a UTR Sports Pickleball event. See you on the court!
                        </div>
                        <PickleballScale
                            value={rating?.pkbRating?.value}
                        />
                    </div>
                </div>
            </div>
            <hr />
            <div className={styles.ratingFooter}>
                <button
                    type="button"
                    className="btn btn-primary btn-block btn-lg text-uppercase"
                    onClick={handleNextClick}
                    data-testid="nuo-v2.pickleball-rating.go-home-btn"
                >
                    {`Go ${getReturnPageName(parsed?.return)}`}
                </button>
            </div>
        </div>
    );
};

export default PickleballRating;
